// Elon University's undergraduate majors (#2652, round 2). Read on 2026-10-01
// from Elon's official Majors, Minors & Programs page (elon.edu), which lists
// every program with its type, the school that offers it and its degree
// links into the 2026-2027 Academic Catalog. Every program typed
// "Undergraduate Major" with a bachelor's degree link is kept, one line per
// degree (A.B., B.S., B.F.A., B.S.B.A., B.S.N., A.B.S.N.); concentrations
// and teacher-licensure tracks of the same degree are folded into their
// major, except Spanish with Teacher Licensure, which the page lists as its
// own major. Left out: minors, graduate programs, and the 3+Co-op and
// Accelerated 3+1 Business pathways, which the page tags as majors but
// which list no bachelor's degree of their own. Nursing A.B.S.N. is the
// accelerated B.S.N. The audition flags quote the page's footnote 4/5.
// "Business Analytics & AI" is the catalog's own name (#2763).
const majors = {
    "slug": "elon-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major on Elon's official Majors, Minors & Programs list, grouped by the school that offers it, with the degree it leads to. Minors, graduate programs and pre-professional pathways are left out.",
    "groups": [
        {
            "name": "Elon College, the College of Arts & Sciences",
            "source": {
                "label": "Elon, Majors, Minors & Programs",
                "url": "https://www.elon.edu/u/academics/majors-minors-programs/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "B.F.A.",
                    "flag": "Audition, portfolio or interview required",
                    "flagSource": "majorsPage"
                },
                {
                    "name": "Anthropology",
                    "degree": "A.B."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "A.B."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Art",
                    "degree": "A.B."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A.",
                    "flag": "Audition, portfolio or interview required",
                    "flagSource": "majorsPage"
                },
                {
                    "name": "Art History",
                    "degree": "A.B."
                },
                {
                    "name": "Arts Administration",
                    "degree": "A.B."
                },
                {
                    "name": "Astronomy",
                    "degree": "A.B."
                },
                {
                    "name": "Astrophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "A.B."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "A.B."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Classical Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Dance Performance & Choreography",
                    "degree": "B.F.A.",
                    "flag": "Audition, portfolio or interview required",
                    "flagSource": "majorsPage"
                },
                {
                    "name": "Dance Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Analytics",
                    "degree": "A.B."
                },
                {
                    "name": "Drama & Theatre Studies",
                    "degree": "A.B."
                },
                {
                    "name": "English",
                    "degree": "A.B."
                },
                {
                    "name": "Environmental & Ecological Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental & Sustainability Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "French",
                    "degree": "A.B."
                },
                {
                    "name": "History",
                    "degree": "A.B."
                },
                {
                    "name": "Human Service Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Independent Major",
                    "degree": "A.B. or B.S."
                },
                {
                    "name": "International & Global Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Mathematics",
                    "degree": "A.B."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Music in Liberal Arts",
                    "degree": "A.B."
                },
                {
                    "name": "Music Performance",
                    "degree": "A.B.",
                    "flag": "Audition, portfolio or interview required",
                    "flagSource": "majorsPage"
                },
                {
                    "name": "Music Production & Recording Arts",
                    "degree": "B.S.",
                    "flag": "Audition, portfolio or interview required",
                    "flagSource": "majorsPage"
                },
                {
                    "name": "Music Theatre",
                    "degree": "B.F.A.",
                    "flag": "Audition, portfolio or interview required",
                    "flagSource": "majorsPage"
                },
                {
                    "name": "Neuroscience",
                    "degree": "A.B."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "A.B."
                },
                {
                    "name": "Physics",
                    "degree": "A.B."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "A.B."
                },
                {
                    "name": "Professional Writing & Rhetoric",
                    "degree": "A.B."
                },
                {
                    "name": "Psychology",
                    "degree": "A.B."
                },
                {
                    "name": "Public Health",
                    "degree": "A.B."
                },
                {
                    "name": "Public Policy",
                    "degree": "A.B."
                },
                {
                    "name": "Religious Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Sociology",
                    "degree": "A.B."
                },
                {
                    "name": "Spanish",
                    "degree": "A.B."
                },
                {
                    "name": "Spanish with Teacher Licensure",
                    "degree": "A.B."
                },
                {
                    "name": "Statistics",
                    "degree": "A.B."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Theatrical Design & Technology",
                    "degree": "A.B.",
                    "flag": "Audition, portfolio or interview required",
                    "flagSource": "majorsPage"
                }
            ]
        },
        {
            "name": "Martha & Spencer Love School of Business",
            "source": {
                "label": "Elon, Majors, Minors & Programs",
                "url": "https://www.elon.edu/u/academics/majors-minors-programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics & AI",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Economics & Consulting",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "A.B."
                },
                {
                    "name": "Entrepreneurship & Innovation",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Financial Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Human Resource Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "International Business Dual Degree",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Project Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "B.S.B.A."
                }
            ]
        },
        {
            "name": "School of Communications",
            "source": {
                "label": "Elon, Majors, Minors & Programs",
                "url": "https://www.elon.edu/u/academics/majors-minors-programs/"
            },
            "majors": [
                {
                    "name": "Cinema & Television Arts",
                    "degree": "A.B."
                },
                {
                    "name": "Digital Content Management",
                    "degree": "A.B."
                },
                {
                    "name": "Journalism",
                    "degree": "A.B."
                },
                {
                    "name": "Media Analytics",
                    "degree": "A.B."
                },
                {
                    "name": "Sport Management",
                    "degree": "B.S."
                },
                {
                    "name": "Strategic Communications",
                    "degree": "A.B."
                },
                {
                    "name": "Visual Communication",
                    "degree": "A.B."
                }
            ]
        },
        {
            "name": "Dr. Jo Watts Williams School of Education",
            "source": {
                "label": "Elon, Majors, Minors & Programs",
                "url": "https://www.elon.edu/u/academics/majors-minors-programs/"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "A.B."
                },
                {
                    "name": "Elementary Education & Special Education",
                    "degree": "A.B."
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "A.B."
                },
                {
                    "name": "Middle Grades Education & Special Education",
                    "degree": "A.B."
                },
                {
                    "name": "Outdoor Leadership & Education",
                    "degree": "B.S."
                },
                {
                    "name": "Science Education",
                    "degree": "A.B."
                },
                {
                    "name": "Secondary Education",
                    "degree": "A.B. or B.S."
                }
            ]
        },
        {
            "name": "School of Engineering & Computing",
            "source": {
                "label": "Elon, Majors, Minors & Programs",
                "url": "https://www.elon.edu/u/academics/majors-minors-programs/"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "A.B."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Health Sciences",
            "source": {
                "label": "Elon, Majors, Minors & Programs",
                "url": "https://www.elon.edu/u/academics/majors-minors-programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "A.B.S.N."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        }
    ]
};

export default majors;
